export default __webpack_public_path__ + "static/media/calendar.295f9058.png";